import {Component, OnInit, ViewChild} from '@angular/core';
import {NzModalRef, NzModalService} from "ng-zorro-antd/modal";
import {AuthenticationService} from "../../../services/utils/authentication.service";
import {TenantSelectorService} from "./service/tenant-selector.service";
import {StorageService} from "front-common-toolkits";
import {TenantService} from "../../../pages/tenant/services/tenant.service";
import {environment} from "../../../../environments/environment";

@Component({
  selector: 'app-tenant-selector',
  templateUrl: './tenant-selector.component.html',
  styleUrls: ['./tenant-selector.component.css']
})
export class TenantSelectorComponent implements OnInit {
  @ViewChild('tenantListContent') tenantListContent;
  tenantSelectionModal: NzModalRef;
  tenantList;
  currentTenant;
  loginType: 'tenant' | 'admin' = environment.isAdmin ? 'admin' : 'tenant';

  constructor(
    private tenantSelectorService: TenantSelectorService,
    private tenantService: TenantService,
    private modalService: NzModalService,
    private authenticationService: AuthenticationService,
    private storageService: StorageService
  ) {
    const tenant = this.storageService.getLocalItem('currentTenant');
    if (tenant) {
      this.currentTenant = tenant;
    }
  }

  ngOnInit(): void {
    this.loadData();
  }

  async loadData() {
    if (this.loginType === 'tenant') {
      this.tenantList = await this.tenantSelectorService.getAvailableTenantList().toPromise();
    } else {
      this.tenantList = [];
    }
  }

  showTenantListModal() {
    this.tenantSelectionModal = this.modalService.create({
      nzTitle: null,
      nzContent: this.tenantListContent,
      nzWidth: 300,
      nzFooter: null
    })
  }

  switchCompany(tenant) {
    this.authenticationService.switchCompany(tenant.tenantId).subscribe(res => {
      this.storageService.setLocalItem('currentTenant', tenant);
      window.location.reload();
    })
  }

  getCurrentTenant() {
    return this.currentTenant;
  }
}
